/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { padWithZeros } from '@squiz/dxp-console-support';

/**
 * Convert datetime (ISO 8601) into a formatted date time string.
 * @param isoDate The datetime in the ISO 8601 format (e.g. 2023-03-29T22:11:44.850Z).
 * @returns The formatted date time string (MMM d, YYYY hh:mm:ss.SSa) to render (e.g. Mar 2, 2023 09:32:01.598pm).
 */
export const convertDatetime = (isoDate: string): string => {
  const date = new Date(isoDate);

  const dateComponent = `${date.toLocaleString('en-US', {
    month: 'short',
  })} ${date.getDate()}, ${date.getFullYear()}`;

  const hours12h = date.getHours() % 12;
  const hoursHelper = hours12h === 0 ? 12 : hours12h;

  const hours = padWithZeros(hoursHelper);
  const minutes = padWithZeros(date.getMinutes());
  const seconds = padWithZeros(date.getSeconds());
  const milliseconds = padWithZeros(date.getMilliseconds(), 3);
  const timeMarker = date.getHours() < 12 ? 'am' : 'pm';
  const timeComponent = `${hours}:${minutes}:${seconds}.${milliseconds}${timeMarker}`;

  return `${dateComponent} ${timeComponent}`;
};
